import React from 'react';
import { observer } from 'mobx-react';
import cxs from 'cxs';
var styles = {
    statGrid: cxs({
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '12px'
    }),
    statItem: cxs({
        textAlign: 'center',
        padding: '12px',
        backgroundColor: '#f8f9fa',
        borderRadius: '6px'
    }),
    statValue: cxs({
        fontSize: '1.5rem',
        fontWeight: 700,
        color: '#333'
    }),
    statLabel: cxs({
        fontSize: '0.75rem',
        color: '#6c757d',
        textTransform: 'uppercase'
    })
};
var SlotStats = observer(function (_a) {
    var slot = _a.slot;
    var totalSold = slot.sold.own + Object.values(slot.sold.external).reduce(function (a, b) { return a + b; }, 0);
    return (React.createElement("div", { className: styles.statGrid },
        React.createElement("div", { className: styles.statItem },
            React.createElement("div", { className: styles.statValue }, slot.capacity),
            React.createElement("div", { className: styles.statLabel }, "Capacidad")),
        React.createElement("div", { className: styles.statItem },
            React.createElement("div", { className: styles.statValue }, totalSold),
            React.createElement("div", { className: styles.statLabel }, "Vendidas")),
        React.createElement("div", { className: styles.statItem },
            React.createElement("div", { className: styles.statValue }, slot.blocked),
            React.createElement("div", { className: styles.statLabel }, "Bloqueadas")),
        React.createElement("div", { className: styles.statItem },
            React.createElement("div", { className: styles.statValue, style: { color: slot.available < 0 ? '#dc3545' : '#28a745' } }, slot.available),
            React.createElement("div", { className: styles.statLabel }, "Disponibles"))));
});
export default SlotStats;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Calendar/components/SlotStats.tsx
// module id = 1614
// module chunks = 0